import React from 'react';
import { attachmentStatuses, companyTypes, formModes, statutoryDocTypes } from '../../constants';
import i18next from "../../i18n";
import { AttachmentsForm, getNewAttachmentId } from '../attachments/AttachmentsForm';
import { AttachmentForm } from '../attachments/AttachmentForm';
import { renderFormHeader, renderAttachments, renderMainFile } from '../document/DocumentHelpers';
import { checkCompanyRegisterCode, checkPersoneRegisterCode } from '../helpers/CheckFunctions';
import { hideModalDialog, showModalDialog } from '../ModalDialog';
import { Svg } from '../Svg';
import { getAttachmentIndicator } from './counterpartyAccreditationHelpers';
import { StatutoryDocsForm } from '../forms/StatutoryDocsForm';
export { settings } from './counterpartyAccreditationHelpers';
export { getCurAttacmentsTypes } from './counterpartyAccreditationHelpers';
export { youControlRequest } from './counterpartyAccreditationHelpers';
export { getAttachmentConfiguration } from './counterpartyAccreditationHelpers';
export { checkAttachmentsMandatoryAdding } from './counterpartyAccreditationHelpers';
export { checkAttachmentsMandatorySigning } from './counterpartyAccreditationHelpers';
export { addSigner } from './counterpartyAccreditationHelpers';
export { addAttacment } from './counterpartyAccreditationHelpers';
export { buildFormItem } from './counterpartyAccreditationHelpers';
export { deleteSigners } from './counterpartyAccreditationHelpers';
export { deleteAccountant } from './counterpartyAccreditationHelpers';
export function checkInputPage() {
	this.incorrectFormat = false;
	const { prop_sxcfc_counterpartyType, prop_sxcfc_counterpartyKind, prop_sxcfc_codeEDRPOU, prop_sxcfc_codeIPN, mainDocuments } = this.state;
	let result = !!(prop_sxcfc_counterpartyType && prop_sxcfc_counterpartyKind &&
		(prop_sxcfc_counterpartyType === companyTypes.Entity ? prop_sxcfc_codeEDRPOU && checkCompanyRegisterCode(prop_sxcfc_codeEDRPOU) : true) &&
		(prop_sxcfc_counterpartyType === companyTypes.Entity || checkPersoneRegisterCode(prop_sxcfc_codeIPN, prop_sxcfc_counterpartyType)))
		&& mainDocuments?.length > 0;
	if (result && prop_sxcfc_counterpartyType === companyTypes.Entity && prop_sxcfc_codeIPN && !checkPersoneRegisterCode(prop_sxcfc_codeIPN, prop_sxcfc_counterpartyType)) {
		result = false;
		this.incorrectFormat = true;
	}
	return result;
}
export function renderinformation() {
	const { templateFolder, formMode } = this.state;
	let attachmentBtns = [];
	if (templateFolder && formMode !== formModes.read) {
		attachmentBtns.push({
			src: "icn-download.svg",
			key: "downloadTemplate",
			title: i18next.t("downloadTemplate"),
			onClick: () => showModalDialog('modalDialog', i18next.t(i18next.t("downloadDocumentTemplate")), "",
				<StatutoryDocsForm
					key={statutoryDocTypes.template}
					docType={statutoryDocTypes.template}
					canEdit={false}
					inPopup={false}
					currentFolder={templateFolder}
				/>,
				"feedPopup middle-size"
			)
		});
	}

	return (
		<div className="doc-form-block" key="informationTab">
			{renderFormHeader.bind(this)()}
			<div className="form-block large-form doc-form x">
				<div className="form-content">
					<div className="row">
						{this.buildFormSection("mainForm")}
						{renderAttachments.bind(this)(attachmentBtns)}
					</div>
				</div>
				{this.renderdocs.bind(this)()}
				<div className="form-content">
					<div className="required-label"><label className="required" />{i18next.t("requiredFields")}</div>
				</div>
			</div>
			{renderMainFile.bind(this)()}
		</div>
	);
}
export function renderdocs() {
	const { attachments, formMode } = this.state;
	const attachmentsChangedCallback = function (attachments) {
		const { attachmentsTypes } = this.state;
		for (let i = 0; i < attachmentsTypes?.length; ++i) {
			if (attachments.findIndex(a => a.documentType === attachmentsTypes[i].value) < 0) {
				attachments.push({
					id: getNewAttachmentId(attachments),
					state: attachmentStatuses.NotAdded,
					documentType: attachmentsTypes[i].value
				});
			}
		}
		this.setState({ attachments: attachments });
	}
	return (
		<div className="doc-form-block" key="docsTab">
			<div className="col-lg-12">
				<label>{i18next.t("additionalFiles")}</label>
			</div>
			<div className="large-form doc-form simple-request">
				{formModes.read !== formMode &&
					<div className="doc-form-info">
						<Svg src="/img/info.svg" />
						<div className="doc-form-info-text">{i18next.t("requestAttachmentsHelpText")}</div>
					</div>
				}
				<AttachmentsForm attachments={attachments} edite={formModes.read !== formMode} typesOfDocumens={this.getCurAttacmentsTypes()} getAttachmentIndicatorHandler={getAttachmentIndicator.bind(this)} changedCallback={attachmentsChangedCallback.bind(this)} />
				{formModes.read !== formMode &&
					<div className="form-group form-group__last">
						<button type="button" className="btn btn-secondary" onClick={() =>
								showModalDialog('modalDialog', i18next.t("addDocument"), "", <AttachmentForm typesOfDocumens={this.getCurAttacmentsTypes()} handleAddDocument={this.addAttacment.bind(this)} onCloseHandler={() => { hideModalDialog('modalDialog'); }} />, "feedPopup middle-form")
							}
						>{i18next.t("addDocument")}</button>
					</div>
				}
			</div>
		</div>
	);
}